import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SiteVisitList from "./List";
import { getSiteVisitList, rmCheckOutRequest } from 'services/redux/networkEngineer/action';
import {getSiteData, calculateDistance, getDistanceData} from "../../../../services/redux/DistanceCalculator/action";


const mapStateToProps = (state) => ({
    siteVisitList: state.NetEnggReducer.siteVisitList,
    siteData: state.leadDataReducer.siteData,
    engDistanceData: state.leadDataReducer.engDistanceData,
    distanceDetails: state.leadDataReducer.distanceDetails,
    rmCheckOutResponse: state.NetEnggReducer.rmCheckOutResponse,

    
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getSiteVisitList,
            getSiteData,
            calculateDistance,
            getDistanceData,
            rmCheckOutRequest,
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(SiteVisitList);
